module.exports = __webpack_public_path__ + "static/media/allCuisines.905350bf.png";